import { ReactNode } from 'react';

import { RowContainer } from './style';

export interface RowProps {
	$gap?: number;
	$reverse?: boolean;
	$hcenter?: boolean;
	$vcenter?: boolean;
	$spaceBetween?: boolean;
	$spaceAround?: boolean;
	$align?: string;
	$fillSpace?: boolean;
	$fillHeight?: boolean;
	children: ReactNode;
}

export function Row({
	$gap = 0,
	$reverse = false,
	$hcenter = false,
	$vcenter = false,
	$spaceBetween = false,
	$spaceAround = false,
	$align = undefined,
	$fillSpace = false,
	$fillHeight = false,
	children,
}: RowProps) {
	return (
		<RowContainer
			$gap={$gap}
			$reverse={$reverse}
			$hcenter={$hcenter}
			$vcenter={$vcenter}
			$align={$align}
			$spaceBetween={$spaceBetween}
			$spaceAround={$spaceAround}
			$fillSpace={$fillSpace}
			$fillHeight={$fillHeight}
		>
			{children}
		</RowContainer>
	);
}
